import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PublicHoliday, PublicHolidayRequest } from '../shared/models/general/public-holiday';

@Injectable({
  providedIn: 'root',
})
export class PublicHolidaysService {
  private readonly apiUrl = environment.apiurl + 'admin/public-holidays';

  constructor(private http: HttpClient) {}

  getAll(country?: string): Observable<PublicHoliday[]> {
    let params = new HttpParams();
    if (country) {
      params = params.set('country', country);
    }
    return this.http.get<PublicHoliday[]>(this.apiUrl, { params });
  }

  add(request: PublicHolidayRequest): Observable<PublicHoliday> {
    return this.http.post<PublicHoliday>(this.apiUrl, request);
  }

  update(id: number, request: PublicHolidayRequest): Observable<PublicHoliday> {
    return this.http.put<PublicHoliday>(`${this.apiUrl}/${id}`, request);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
